import { agencyEnum, countryEnum, datatype, filtertype, queryInput } from 'API';
import { Storage } from 'aws-amplify';

import AuthContext from 'context/AuthContext';
import { useCampaignContext } from 'context/CampaignContext';
import { useCustomReportContext } from 'context/CustomReportContext';
import { useTemplateContext } from 'context/TemplateContext';
import { find, get } from 'lodash';
import { getStartDate, getEndDate } from 'methods/dateMethods';
import { getQueryFilters } from 'methods/queryFiltersMethod';
import { useContext, useEffect, useState } from 'react';
const { REACT_APP_USER_FILES_S3_BUCKET, REACT_APP_AGENCY } = process.env;

export const useGetStoredQuery = (queryID: string, componentid?: string): readonly [queryInput | undefined] => {
  const { user } = useContext(AuthContext);
  const { activeCampaign: classicCampaign, activeSubCampaign } = useCampaignContext();
  const { transformedACDetailsReport, activeCustomReport } = useCustomReportContext();
  const [query, setQuery] = useState<queryInput>();
  const { fetchedPlaceholders } = useTemplateContext();
  const arrayOfViewsUsedinDefaultTemplate = [
    {
      viewName: 'fozzie_facebook_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_facebook_custom_conversions_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_facebook_conversions_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_facebook_frequency_campaign_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_facebook_frequency_fb_campaign_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_facebook_frequency_adset_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_facebook_frequency_ad_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_google_dv360_youtube_excluded_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_google_dv360_conversions_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_tiktok_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_tiktok_frequency_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_snapchat_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_snapchat_conversions_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_snapchat_frequency_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_campaign_manager_bvod_excluded_',
      database: 'data_lake_denmark',
    },
    {
      viewName: 'fozzie_linkedin_',
      database: 'data_lake_denmark',
    },
  ];
  const activeCampaign = classicCampaign || transformedACDetailsReport;
  // console.log('activeCampaign in useGetStoredQuery', transforemdACDetailsReport);

  useEffect(() => {
    const fetchStoredQuery = async () => {
      const link = await Storage.get(`${queryID}.json`, {
        level: 'protected',
        identityId: 'queries',
        region: 'eu-west-1',
        bucket: REACT_APP_USER_FILES_S3_BUCKET, //THE BUCKET
      });

      try {
        const response = await fetch(`${link}`);
        const data = (await response.json()) as queryInput & { queryid?: string };
        // CHANGE CAMPAIGN ID
        const findCampaignFilter = data.query.filters?.findIndex((el: any) => el.column === 'campaign_id');
        // console.log('KUKUMENEO filterz in useGetStoredQuery with fetchedPlaceholders', data.query);
        if (findCampaignFilter !== -1 && data.query.filters) {
          const filterObject = data.query.filters[findCampaignFilter as number];
          if (filterObject) {
            const filter = filterObject.filter;
            const campaignId = activeCampaign?.campaignId;
            const subCampaignId = activeSubCampaign?.subcampaignId;
            if (
              (filter && campaignId && subCampaignId === -1) ||
              (filter && campaignId && subCampaignId !== -1 && componentid?.startsWith('BVOD'))
            ) {
              if (campaignId.toString().startsWith('100')) {
                filter.filtertype = filtertype.IN;
                filter.list = activeCampaign?.childCampaigns?.map((e) => e?.campaignId.toString()) as string[];
              } else if (campaignId.toString().startsWith('200')) {
                if (transformedACDetailsReport) {
                  const campaignList = activeCustomReport?.Filters?.find((filter) => filter?.column === 'campaign_id')
                    ?.filter?.list;

                  const nonNullCampaignList = campaignList
                    ? campaignList.filter((item): item is string => item !== null)
                    : undefined;
                  const filterz = getQueryFilters(transformedACDetailsReport, nonNullCampaignList);
                  // data.query.filters = [...(data.query.filters || []), ...(filterz || [])];
                } else {
                  const filterz = getQueryFilters(activeCampaign);
                  if (fetchedPlaceholders.length > 0) {
                    filter.value = activeCampaign.parentReference?.toString();
                    filterz?.forEach((f) => {
                      const existingFilterIndex = data.query.filters?.findIndex((el: any) => el.column === f.column);
                      if (existingFilterIndex !== undefined && existingFilterIndex !== -1) {
                        // If the filter already exists, update it
                        data.query.filters![existingFilterIndex] = f;
                      } else {
                        // If the filter does not exist, add it to the filters array
                        data.query.filters = [...(data.query.filters || []), f];
                      }
                    });
                  } else {
                    // Merge filterz into the existing filters array rather than replacing it.
                    // This preserves user-defined filters (e.g. site_dcm, creative_name) that
                    // are not part of the campaign/date filter set returned by getQueryFilters.
                    // Mirrors the same merge logic used in the fetchedPlaceholders branch above.
                    filterz?.forEach((f) => {
                      const existingFilterIndex = data.query.filters?.findIndex((el: any) => el.column === f.column);
                      if (existingFilterIndex !== undefined && existingFilterIndex !== -1) {
                        data.query.filters![existingFilterIndex] = f;
                      } else {
                        data.query.filters = [...(data.query.filters || []), f];
                      }
                    });
                  }
                }
              } else {
                filter.value = campaignId.toString();
                delete filter.list;
                // const kita = getQueryFilters(activeCampaign);

                // data.query.filters = kita;
              }
            } else if (filter && campaignId && subCampaignId && subCampaignId !== -1) {
              if (componentid && componentid.startsWith('BVOD')) {
                console.log('Bvod component, no subcampaign filter');
              } else {
                data.query.filters = [
                  {
                    column: 'subcampaign_id',
                    filter: {
                      filtertype: filtertype.EQUAL,
                      datatype: datatype.NUMBER,
                      value: subCampaignId.toString(),
                    },
                  },
                ];
              }
            }
          }
        }
        //CHANGE CLIENTS
        data.clients = [
          {
            country: countryEnum[activeCampaign?.ClientCountry as keyof typeof countryEnum],
            client: activeCampaign?.ClientCode as string,
          },
        ];

        // CHANGE CC_NAME
        data.query.detailedDimensions?.forEach((el: any) => {
          if (
            el.column === 'conversion_name' ||
            el.column === 'filter_name' ||
            el.column === 'activity' ||
            el.column === 'floodlight_activity_name'
          ) {
            el.name = 'CC_name';
          }
        });
        data.query.metrics?.forEach(
          (el: any) => {
            if (
              el.column === 'custom_conversions_value' ||
              el.column === 'custom_conversions' ||
              el.column === 'total_conversions'
            ) {
              el.name = 'custom_conversion';
            }
          },
          // TODO ADD THE OTHER 2 AS WELL
          // added the 2 more for that
        );

        //REMOVE FILTERS IF FETCHED PLACEHOLDERS
        if (fetchedPlaceholders.length > 0) {
          data.query.filters = data.query.filters?.filter((el: any) => {
            return (
              el.column === 'campaign_id' ||
              el.column === 'date' ||
              el.column === 'subcampaign_id' ||
              el.column === 'conversion_name' ||
              el.column === 'filter_name' ||
              el.column === 'activity' ||
              el.column === 'floodlight_activity_name'
            );
          });
          // filter in case of custom reports
          // const filterz = getQueryFilters(activeCampaign);

          // data.query.filters = [...(data.query.filters || []), ...(filterz || [])];
        }

        // CHANGE USER
        const newUser = {
          name: user?.username,
          agency: agencyEnum[`${REACT_APP_AGENCY?.toUpperCase()}` as keyof typeof agencyEnum],
          country: countryEnum.DK,
        };
        data.user = newUser;
        //DELETE QUERY ID FROM RESUULT
        delete data.queryid;
        //CHANGE DATE
        data.date.from = getStartDate(36);
        data.date.to = getEndDate();
        setQuery(data);

        // MAYBE CHANGE VIEWS
        const deepEqual = (arr1: any[], arr2: any[]): boolean => {
          if (arr1.length !== arr2.length) return false;
          return arr1.every((obj, index) => {
            return Object.keys(obj).every((key) => obj[key] === arr2[index][key]);
          });
        };

        if (deepEqual(data.views, arrayOfViewsUsedinDefaultTemplate)) {
          const getDatabase = (country: string | undefined) => {
            switch (country) {
              case 'DK':
                return 'data_lake_denmark';
              case 'SE':
                return 'data_lake_sweden';
              case 'FI':
                return 'data_lake_finland';
              default:
                return 'data_lake_norway';
            }
          };
          const platforms = [
            'google_dv360_youtube_excluded',
            'facebook',
            'adform_bvod_excluded',
            'campaign_manager_bvod_excluded',
            'google_ads_video',
            'google_dv360_youtube',
            'tiktok',
            'snapchat',
            'linkedin',
            'readpeak',
            'taboola',
            'pinterest',
            'marathon_digital_tracking',
            'campaign_manager_olv',
            'adform_olv',
          ];

          const views = platforms.map((platform) => ({
            viewName: `fozzie_${platform}_`,
            database: getDatabase(activeCampaign?.ClientCountry),
          }));
          data.views = views;
        }
        // console.log('QUERY ON STORED FOR', componentid, data);
      } catch (e) {
        console.error('error fetching storedQuery', e);
      }
    };

    if (queryID) {
      fetchStoredQuery();
    } else {
      setQuery(undefined);
    }
  }, [activeCampaign, activeSubCampaign?.subcampaignId, fetchedPlaceholders, queryID, user?.username]);
  return [query];
};
